import { Report } from 'pages/reporting/shared/types'

import { Cover } from './sections/Cover'
import { DataOverviewSection } from './sections/DataOverview'
import { ImagesSection } from './sections/Images'
import { InspectionDataSheetSection } from './sections/InspectionDataSheet'
import { InspectionSummary } from './sections/InspectionSummary'
import { IntroToRUGSection } from './sections/IntroToRUG'
import { PDFGeneration } from './sections/PDFGeneration'
import { ReportReview } from './sections/ReportReview'
import { RugDataImagesSection } from './sections/RugDataImages'
import { SectionAddendumsSection } from './sections/SectionAddendums'
import { TableOfContents } from './sections/TableOfContents'

export const rugReportForSPA: Report = {
  coverSection: Cover,
  tocSection: TableOfContents,
  sections: [
    InspectionSummary,
    InspectionDataSheetSection,
    DataOverviewSection,
    ImagesSection,
    RugDataImagesSection,
    SectionAddendumsSection,
  ],
  reviewSection: ReportReview,
  pdfGenerationSection: PDFGeneration,
  staticSections: [IntroToRUGSection],
}
